var gridster;
var showcaseEditor = function(options) {
  var grid_size = 140;
  var grid_margin = 2;
  var grid_height;
  var block_params = {
    max_width: 7,
    max_height: 5,
  };
  var resizable_conf;
  var resizable_conf_modal;
  var cell_init;
  var last_color = '#ffffff';
  var grid_width;
  var modalX;
  var modalY;
  var modal_min_width;
  var selected_cell;
  var orig_width, orig_height, orig_z;

  var edit_callback;
  var loadCell;

  $(function() {
    modal_min_width = grid_size * 2 + grid_margin * 2;
    $('#new-modal').css({
      width: modal_min_width + 'px',
      height: grid_size + 'px',
      top: '-1000px',
      left: '-1000px',
    });

    grid_width =
      grid_size * (block_params.max_width - 1) +
      grid_margin * 2 * (block_params.max_width - 1);
    $('.gridster').css({
      width: grid_width + 'px',
    });

    $('.tools').css({
      width: grid_width + 'px',
    });

    $('.showcase-title').css({
      width: grid_width - 2 * 58 + 'px',
    });

    function resizeBlock(elmObj) {
      var elmObj = $(elmObj);
      var w = elmObj.width() - grid_size;
      var h = elmObj.height() - grid_size;

      for (var grid_w = 1; w > 0; w -= grid_size + grid_margin * 2) {
        grid_w++;
      }

      for (var grid_h = 1; h > 0; h -= grid_size + grid_margin * 2) {
        grid_h++;
      }

      gridster.resize_widget(elmObj, grid_w, grid_h);
      gridster.set_dom_grid_height();
    }

    resizable_conf_modal = {
      grid: [grid_size + grid_margin * 2, grid_size + grid_margin * 2],
      animate: false,
      minWidth: grid_size * 2,
      minHeight: grid_size,
      maxWidth: block_params.max_width * grid_size,
      maxHeight: block_params.max_height * grid_size,
      autoHide: false,
    };

    resizable_conf = {
      grid: [grid_size + grid_margin * 2, grid_size + grid_margin * 2],
      animate: false,
      minWidth: grid_size,
      minHeight: grid_size,
      maxWidth: block_params.max_width * grid_size,
      maxHeight: block_params.max_height * grid_size,
      autoHide: true,
      start: function(event, ui) {
        grid_height = gridster.$el.height();
      },
      resize: function(event, ui) {
        //set new grid height along the dragging period
        var delta = grid_size + grid_margin * 2;
        if (event.offsetY > gridster.$el.height()) {
          var extra = Math.floor((event.offsetY - grid_height) / delta + 1);
          var new_height = grid_height + extra * delta;
          gridster.$el.css('height', new_height);
        }
      },
      stop: function(event, ui) {
        var resized = $(this);
        setTimeout(function() {
          resizeBlock(resized);
          if (options.save) options.save(gridster.serialize());
        }, 300);
      },
    };

    loadCell = function($cell, url) {
      $cell = $($cell);
      if (options.loadCell) {
        options.loadCell(url, $cell.children('.cell-contents'));
      }
    };

    edit_callback = function(evt) {
      if ($(evt.target).hasClass('remove-cell')) {
        return;
      }

      var $elt = $(this);
      orig_width = $elt.width();
      orig_height = $elt.height();
      orig_z = $elt.css('z-index');

      selected_cell = $elt;

      if (selected_cell.attr('data-url')) {
        $('#url').val(selected_cell.attr('data-url'));
      } else {
        $('#url').val('');
      }

      $('#search').select2('val', '');

      $('#new-modal')
        .modal('show')
        .css('background-color', 'transparent')
        .css('z-index', 1998)
        .css('width', Math.max($elt.width(), modal_min_width) + 'px')
        .css('height', $elt.height() + 'px')
        .css('top', $elt.offset().top + 'px')
        .css('left', $elt.offset().left + 'px')
        .draggable({ disabled: true })
        .resizable({ disabled: true });

      $elt.css({
        width: $('#new-modal').width() + 'px',
        height: $('#new-modal').height() + 'px',
        'z-index': 999,
      });

      $('#new-submit').text($('#new-submit').attr('data-save-text'));
    };

    cell_init = function($cell) {
      var clearTimer = function() {
        clearTimeout($(this).data('pressTimer'));
      };

      if (options.editable) {
        var $remove = $('<button class="remove-cell">&times;</button>');
        $cell.prepend($remove);
        $remove.hide();
        $cell
          .mouseover(function() {
            $(this)
              .children('.remove-cell')
              .show();
          })
          .mouseout(function() {
            $(this)
              .children('.remove-cell')
              .hide();
          });

        $cell.resizable(resizable_conf);

        $cell.find('.ui-resizable-handle').hover(
          function() {
            gridster.disable();
          },
          function() {
            gridster.enable();
          }
        );

        $cell.mousedown(function(evt) {
          var self = this;
          $(this).data(
            'pressTimer',
            window.setTimeout(function() {
              $(self).trigger('mouseup');
              edit_callback.call(self, evt);
            }, 600)
          );
        });

        $cell
          .mouseup(clearTimer)
          .mouseout(clearTimer)
          .mousemove(clearTimer);
      } else {
        var $overlayLink = $('<a>');
        $overlayLink
          .addClass('link-overlay')
          .attr('href', $cell.attr('data-url'));

        $cell.append($overlayLink);
      }
    };

    gridster = $('.gridster ul')
      .gridster({
        avoid_overlapped_widgets: true,
        widget_margins: [grid_margin, grid_margin],
        widget_base_dimensions: [grid_size, grid_size],
        serialize_params: function($w, wgd) {
          return {
            x: wgd.col,
            y: wgd.row,
            width: wgd.size_x,
            height: wgd.size_y,
            id: $($w).attr('data-id'),
            bgcolor: $($w).css('background-color'),
            url: $($w).attr('data-url'),
          };
        },
        min_rows: block_params.max_height,
        max_size_x: block_params.max_width - 1,

        draggable: {
          stop: function() {
            if (gridster) {
              if (options.save) options.save(gridster.serialize());
            }
          },
        },
      })
      .data('gridster');

    if (options.editable) {
      $('.gridster').on('click', '.remove-cell', function() {
        var $elt = $(this).parent('li');
        gridster.remove_widget($elt);
        if (options.save) options.save(gridster.serialize());
      });
    }

    if (options.background) {
      $('.showcase').css('background-color', options.background);
    }

    if (options.editable) {
      /*
      $('#cell-color').attr('data-color', last_color).colorpicker().on('changeColor', function(ev) {
        if (selected_cell) {
          last_color = '#' + ev.color.toHex();
          selected_cell.css('background-color',  last_color);
          $('.modal-backdrop').fadeOut();
        } else {
          $(this).parents('#new-modal').css('background-color',  '#' + ev.color.toHex());
        }

      }).on('show', function(ev) {
        if (selected_cell) {
          last_color = selected_cell.css('background-color');
          
          ev.color.setColor(last_color);
          console.log(ev.color.toHex());
        } else {
          ev.color.setColor(last_color);
          console.log(ev.color.toHex());
          $(this).parents('#new-modal').css('background-color',  last_color);
        }

        console.log('SET ' + last_color);
      });
      */

      $('#add-button')
        .click(function() {
          selected_cell = null;
          //console.log(modalY, modalX);
          $('#new-modal')
            .modal('show')
            .css('background-color', last_color)
            .css('z-index', 1999)
            .css('top', modalY + 'px')
            .css('left', modalX + 'px')
            .draggable({ disabled: false })
            .resizable({ disabled: false });
          $('#new-submit').text($('#new-submit').attr('data-add-text'));
        })
        .tooltip({
          title: 'Add',
          placement: 'bottom',
        });

      $('#new-modal').resizable(resizable_conf_modal);

      $('#new-modal').draggable();

      $('#new-submit').click(function() {
        var url;
        if (selected_cell) {
          url = selected_cell.attr('data-url');
          if (url != null) {
            loadCell(selected_cell, url);
            $('#new-modal').modal('hide');
          }
        } else {
          modalX = $('#new-modal').offset().left;
          modalY = $('#new-modal').offset().top;
          //console.log(modalY, modalX);

          var $new_cell = $('<li><span class="cell-contents"></span></li>');
          var w, h;

          w = Math.round($('#new-modal').width() / (grid_size + grid_margin));
          h = Math.round($('#new-modal').height() / (grid_size + grid_margin));

          gridster.add_widget($new_cell, w, h);
          gridster.set_dom_grid_height();
          cell_init($new_cell);
          last_color = $('#new-modal').css('background-color');
          $new_cell.css('background-color', last_color);

          url = $('#url').val();
          $new_cell.attr('data-url', url);
          loadCell($new_cell, url);

          var offset = $new_cell.offset();
          $('#new-modal').animate(
            {
              left: offset.left + 'px',
              top: offset.top + 'px',
            },
            function() {
              $('#new-modal').modal('hide');
            }
          );
        }
      });

      var color = $('.showcase').css('background-color');
      $('#bg-button')
        .attr('data-color', color)
        .colorpicker()
        .on('changeColor', function(ev) {
          $('.showcase').css('background-color', '#' + ev.color.toHex());
        })
        .tooltip({
          title: 'Change Background',
          placement: 'bottom',
        });

      $('#bg-button')
        .colorpicker()
        .on('hide', function() {
          if (options.saveBackground)
            options.saveBackground($('.showcase').css('background-color'));
        });

      $('#new-modal').on('hide', function(evt) {
        if ($(evt.target).attr('id') === 'new-modal' && selected_cell) {
          selected_cell.css({
            width: orig_width + 'px',
            height: orig_height + 'px',
            'z-index': orig_z,
          });
        } else if ($(evt.target).attr('id') === 'cell-color') {
          if (selected_cell) {
            $('.modal-backdrop').fadeIn();
          }
        }

        if (options.save) options.save(gridster.serialize());
      });

      $('#showcase-title')
        .on('focus', function() {
          $('#title-color')
            .css({
              position: 'absolute',
              left:
                $('#showcase-title').offset().left +
                $('#showcase-title').width() -
                32 +
                'px',
              top: $('#showcase-title').offset().top + 'px',
              'background-color': $('#showcase-title').css('color'),
            })
            .attr('data-color', $('#showcase-title').css('color'));
          $('#title-color').show();
        })
        .on('blur', function() {
          if (options.saveTitle)
            options.saveTitle(
              $('#showcase-title').val(),
              $('#showcase-title').css('color')
            );
        });

      $(document).on('click', function(evt) {
        var id = $(evt.target).attr('id');
        if (id !== 'showcase-title' && id !== 'title-color') {
          $('#title-color').hide();
        }
      });

      if (options.titleColor) {
        $('#showcase-title').css('color', options.titleColor);
      }
      if (options.title) {
        $('#showcase-title').val(options.title);
      }
      $('#title-color')
        .colorpicker()
        .on('changeColor', function(ev) {
          //console.log(ev.color.toHex());
          $('#showcase-title').css('color', '#' + ev.color.toHex());
          $('#title-color').css('background-color', '#' + ev.color.toHex());
        })
        .tooltip({
          title: 'Change Title',
          placement: 'bottom',
        });

      $('#title-color')
        .colorpicker()
        .on('hide', function(ev) {
          if (options.saveTitle)
            options.saveTitle(
              $('#showcase-title').val(),
              $('#showcase-title').css('color')
            );
        });

      $('#search').change(function(evt) {
        var url = options.siteRoot + '/' + evt.val;
        $('#url').val(url);
        if (selected_cell) {
          selected_cell.attr('data-url', url);
        }
      });

      $('#url').on('blur', function(evt) {
        var url = $(this).val();
        if (selected_cell) {
          selected_cell.attr('data-url', url);
        }
      });

      $('.gridster').on('dblclick', 'li', edit_callback);
    } else {
      gridster.disable();
    }

    $('.gridster li').each(function() {
      var url;
      cell_init($(this));

      url = $(this).attr('data-url');
      if (url) {
        loadCell($(this), url);
      }
    });

    $('.showcase-content').show();

    modalY = $('.gridster').offset().top + grid_margin;
    modalX = $('.gridster').offset().left + grid_margin;
  });
};
